import { NavLink, Route, Routes } from 'react-router-dom';
import { makeStyles, tokens, Title3, Text } from '@fluentui/react-components';
import Dashboard from './pages/Dashboard';
import Chat from './pages/Chat';
import Batches from './pages/Batches';
import Evaluations from './pages/Evaluations';
import Security from './pages/Security';
import BenchmarkLab from './pages/BenchmarkLab';
import MatrixLab from './pages/MatrixLab';
import PromptOptimization from './pages/PromptOptimization';
import GoldenDatasets from './pages/GoldenDatasets';
import ArchitectureExplorer from './pages/ArchitectureExplorer';
import FlightRecorder from './pages/FlightRecorder';
import Governance from './pages/Governance';
import BusinessImpact from './pages/BusinessImpact';
import RoutingSimulator from './pages/RoutingSimulator';
import Simulation from './pages/Simulation';
import SimulationResults from './pages/SimulationResults';

const useStyles = makeStyles({
  root:    { display: 'grid', gridTemplateColumns: '240px 1fr', minHeight: '100vh' },
  sidebar: {
    background: tokens.colorNeutralBackground2,
    borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
    padding: '24px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  brand: { marginBottom: '24px' },
  navLink: {
    padding: '10px 12px',
    borderRadius: '6px',
    color: tokens.colorNeutralForeground2,
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500,
    ':hover': { background: tokens.colorNeutralBackground3 },
  },
  navLinkActive: {
    background: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground1,
  },
  main:    { padding: '24px 32px', overflow: 'auto' },
});

export default function App() {
  const s = useStyles();
  return (
    <div className={s.root}>
      <aside className={s.sidebar}>
        <div className={s.brand}>
          <Title3 as="h1">LLM Eval</Title3>
          <Text size={200}>Enterprise Platform</Text>
        </div>
        <NavLink to="/simulation"  className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Persona Simulation</NavLink>
        <NavLink to="/simulation-results" className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Simulation Results</NavLink>
        <NavLink to="/"            className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`} end>Dashboard</NavLink>
        <NavLink to="/architecture" className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Architecture</NavLink>
        <NavLink to="/traces"      className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Flight Recorder</NavLink>
        <NavLink to="/governance"  className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Governance</NavLink>
        <NavLink to="/impact"      className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Business Impact</NavLink>
        <NavLink to="/routing"     className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Routing Simulator</NavLink>
        <NavLink to="/chat"        className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Chat / RAG Flow</NavLink>
        <NavLink to="/benchmarks"  className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Benchmark Lab</NavLink>
        <NavLink to="/matrix"      className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Matrix Benchmark</NavLink>
        <NavLink to="/prompts"     className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Prompt Optimization</NavLink>
        <NavLink to="/datasets"    className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Golden Datasets</NavLink>
        <NavLink to="/batches"     className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Documents</NavLink>
        <NavLink to="/evaluations" className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Evaluations</NavLink>
        <NavLink to="/security"    className={({ isActive }) => `${s.navLink} ${isActive ? s.navLinkActive : ''}`}>Security Lab</NavLink>
      </aside>
      <main className={s.main}>
        <Routes>
          <Route path="/"            element={<Dashboard />} />
          <Route path="/architecture" element={<ArchitectureExplorer />} />
          <Route path="/traces"      element={<FlightRecorder />} />
          <Route path="/governance"  element={<Governance />} />
          <Route path="/impact"      element={<BusinessImpact />} />
          <Route path="/routing"     element={<RoutingSimulator />} />
          <Route path="/chat"        element={<Chat />} />
          <Route path="/benchmarks"  element={<BenchmarkLab />} />
          <Route path="/matrix"      element={<MatrixLab />} />
          <Route path="/simulation"  element={<Simulation />} />
          <Route path="/simulation-results" element={<SimulationResults />} />
          <Route path="/prompts"     element={<PromptOptimization />} />
          <Route path="/datasets"    element={<GoldenDatasets />} />
          <Route path="/batches"     element={<Batches />} />
          <Route path="/evaluations" element={<Evaluations />} />
          <Route path="/security"    element={<Security />} />
        </Routes>
      </main>
    </div>
  );
}
